import { render } from "./Activities.vue?vue&type=template&id=6d9d1e5c&scoped=true"
import script from "./Activities.vue?vue&type=script&lang=js"
export * from "./Activities.vue?vue&type=script&lang=js"

import "./Activities.vue?vue&type=style&index=0&id=6d9d1e5c&scoped=true&lang=css"

import exportComponent from "C:\\Users\\ken\\Documents\\GitHub\\KasongNursingHome\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6d9d1e5c"]])

export default __exports__